import "./App.css";

import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
// import About from "./components/About";
import React ,{ useState } from "react";
import Alert from "./components/Alert";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   // Link
// } from "react-router-dom";




function App(){
  const [mode, setMode] = useState('light');

  const [alert, setAlert]=useState(null);

  const showAlert=(message, type)=>{
     setAlert({
      msg:message,
      type:type
     })
     setTimeout(() => {
      setAlert(null);
     }, 1500);
  }

  const toggleMode =()=>{
     if(mode==='light'){
      setMode('dark');
      document.body.style.backgroundColor='#0e2d5a';
      showAlert("Dark mode has been enabled", "success");
      document.title='Maddyutils - Dark Mode';
      // setInterval(() => {
      //   document.title='MaddyUitls is Amazing Tool';
      // }, 2000);
      // setInterval(() => {
      //   document.title='Install Maddyutils Now';
      // }, 1500);
     }
     else{
      setMode('light');
      document.body.style.backgroundColor='white';
      showAlert("Light mode has been enabled", "success");
      document.title='Maddyutils - Light Mode';
     }
  }

  return (
    <>
    {/* <Router> */}
      <Navbar title="MaddyUtils" mode={mode} toggleMode={toggleMode} />
      <Alert alert={alert}/>
      <div className="container my-3">

      {/* <Routes>
          <Route exact path="/about" element={<About/>}>
           
          </Route>
      
          <Route exact path="/" element={<TextForm showAlert={showAlert} heading="Enter the text to analyze below" mode={mode}/>}>
          </Route>

        </Routes>
     */}

     <TextForm showAlert={showAlert} heading="Enter the text to analyze below" mode={mode}/>
     
      

      
      </div>
     
      {/* </Router> */}
 
    </>
  );
}

export default App;
